import { formatRoundedNumber } from '@/lib/formatUtils';
import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';

interface BottomBarProps {
  totalAmount?: number;
  totalQuantity?: number;
  totalTax?: number;
  totalPayment?: number;
}

function BottomBar({ totalAmount = 0, totalQuantity = 0, totalTax = 0, totalPayment = 0 }: BottomBarProps) {
  return (
    <div className='w-full border-t bg-white px-4 py-2'>
      <div className='flex'>
        <div className='flex flex-col'>
          {/* Column 1 */}
          <div className='flex items-center'>
            <Label className='w-32 font-medium'>Tổng số lượng</Label>
            <div className='w-[250px] pb-1'>
              <FormField name='t_so_luong' value={formatRoundedNumber(totalQuantity, 6)} />
            </div>
          </div>
        </div>

        <div className='ml-4 flex flex-col'>
          <div className='flex items-center'>
            <Label className='w-32 font-medium'>Tổng tiền</Label>
            <div className='w-[250px]'>
              <FormField name='t_tien_nt' value={formatRoundedNumber(totalAmount)} />
            </div>
            <FormField name='t_tien' value={formatRoundedNumber(totalAmount)} className='hidden' />
          </div>
          <div className='flex items-center'>
            <Label className='w-32 font-medium'>Tổng thuế</Label>
            <div className='w-[250px]'>
              <FormField name='t_thue_nt' value={formatRoundedNumber(totalTax)} />
            </div>
            <FormField name='t_thue' value={formatRoundedNumber(totalTax)} className='hidden' />
          </div>
        </div>

        <div className='ml-auto flex flex-col'>
          {/* Column 3 */}
          <div className='flex items-center'>
            <Label className='w-32 font-medium'>Tổng thanh toán</Label>
            <div className='w-[250px]'>
              <FormField name='t_tt_nt' value={formatRoundedNumber(totalPayment)} />
            </div>
            <FormField name='t_tt' value={formatRoundedNumber(totalPayment)} className='hidden' />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BottomBar;
